class KukunAccordion {
    /**
     * @param {HTMLElement} AccordionContainer HTMLElement with the accordion container where it will be created.
     * @param {object} parameters Object with a set of parameters. If undefined, default configuration will be used instead.
     * @param {string} [parameters.width]elements width. Default value: 100%
     * @param {boolean} [parameters.expandable] if content is expandable. Default value: false.
     * @param {string} [parameters.innerMargin] Margin (top and bottom) between contents. Default value: 18px
     * @param {boolean} [parameters.innerScroll] If window should be scrolled to content after clicking. Default value: true.
     * @param {string} [parameters.bgColor] Background color of buttons. Default value: #FFF.
     * @param {string} [parameters.textColor] Text color of buttons. Default value: #CCCCCC.
     * @param {number} [parameters.startBy] Index of accordion content to be opened on creation (starting by 0). Default: undefined.
     * @param {boolean} [parameters.openAll] Open every content on init. NOTE: Requires parameters.expandable equal to TRUE.
     */
    constructor(AccordionContainer, parameters) {
        this.container = AccordionContainer;
        this.parameters = parameters;
        this.wrappers = AccordionContainer.getElementsByClassName("k-accordion-wrapper");
        this.buttons = AccordionContainer.getElementsByClassName("k-accordion-button");
        this.contents = AccordionContainer.getElementsByClassName("k-accordion-content");
        this._last = undefined;
        this.expandable = false;
        this.openIndex = undefined;
        this.autoScroll = true;
        this._addParameters();
        this._loadEvents();
    }

    _toggleContent(content, accordionButton){
        if(this.isOpened(content)){ // close
            content.style.maxHeight = null;
        }else { // open
            content.style.maxHeight = content.scrollHeight + "px";
            if(this.autoScroll)
                setTimeout(() => {
                    content.scrollIntoView({behavior : "smooth"});
                }, 100);
        }
        content.classList.toggle("k-accordion-show");
        accordionButton.classList.toggle("k-accordion-open");
    }

    _resizeObserver(content) {
        const children = content.children;

        if (ResizeObserver) {

            const ro = new ResizeObserver(items => {

                for (let item of items) {

                    if(this.isOpened(content)){
                        content.style.maxHeight = content.scrollHeight + "px";
                    }
                }
            });

            for (let child of children) {
                ro.observe(child);
            }
        }
    }

    _loadEvents() {
        Object.keys(this.buttons).forEach(key => {
           const contentSibling = this.contents[key];
           this._resizeObserver(contentSibling);

           this.buttons[key].addEventListener('click', (e) => {
               const contentSibling = this.contents[key];
               const accordionButton = this.buttons[key];
               let isLast;
               this._toggleContent(contentSibling, accordionButton);

               if(this._last) {
                   isLast = this._last === contentSibling;
                   if(!isLast)
                       this._toggleContent(this._last, accordionButton);
               }

               if(!this.expandable) // No need to control last clicked if content is expandable
                   this._last = (isLast)? undefined : contentSibling;
           })
        });
    }
    _addParameters() {
        if ("width" in this.parameters)
            this.container.style.width = this.parameters.width;

        if ("expandable" in this.parameters)
            this.expandable = this.parameters.expandable;

        if ("autoScroll" in this.parameters)
            this.autoScroll = this.parameters.autoScroll;

        if ("innerMargin" in this.parameters)
            Object.keys(this.wrappers).forEach(key => {
                this.wrappers[key].style.margin = this.parameters.innerMargin + " 0px";
            });

        if ("bgColor" in this.parameters)
            Object.keys(this.buttons).forEach(key => {
                this.buttons[key].style.backgroundColor = this.parameters.bgColor;
            });

        if ("textColor" in this.parameters)
            Object.keys(this.buttons).forEach(key => {
                this.wrappers[key].style.color = this.parameters.textColor;
            });

        if ("startBy" in this.parameters) {
            if (this.parameters.startBy >= 0 && this.parameters.startBy < this.contents.length){
                this.openIndex = this.parameters.startBy;
                this._toggleContent(this.contents[this.openIndex], this.buttons[this.openIndex]);
            }
        }

        if("openAll" in this.parameters && this.parameters.openAll === true)
            this.openAll();
    }

    /* Note: In order to use this function, 'this.expandable' must be true, otherwise it wont make sense since it will
        close one after the other. */
    openAll() {
        for(let key = 0; key < this.contents.length; key++) {
            if(!this.isOpened(this.contents[key]))
                this._toggleContent(this.contents[key], this.buttons[key]);
        }
    }

    isOpened(content) {
        return content.style.maxHeight;
    }

    remove() {
        this.container.style.display = 'none';
        this.container.style.visibility = 'hidden';
    }
}

let modalInstances = [];

const init = (background_rappers, modalParameters) => {
    if (background_rappers) {
        if (typeof background_rappers.length == 'undefined') {
            const htmlElement = background_rappers;
            const parameters = modalParameters;
            modalInstances = new KukunAccordion(htmlElement, parameters);
        } else {
            for (let i = 0; i < background_rappers.length; i++) {
                const htmlElement = background_rappers[i];
                let modalInstance = new KukunAccordion(htmlElement);
                modalInstances.push(modalInstance);
            }
        }
    }

    return modalInstances;
};


export {
    init
};